import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GeoService }             from './services/geo.service';
import { RandonneursService }     from './services/randonneurs.service';
import { Sha256 }                 from './services/sha256';
import { MapLayer }               from 'app/shared/data/map-layer';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
  ],
  exports: [
  ],
  providers: [RandonneursService, GeoService, Sha256]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/shared.module.ts